import superagent from '@ott/superagent';

import T from '../types';

import prepareCountries from '../helpers/prepareCountries';

export default () => {
  return {
    promise: async () => {
      const {
        body: { result },
      } = await superagent.get('/_tours/getDestinationCountries/');

      return prepareCountries(result.countries);
    },
    types: [
      T.GET_DESTINATION_COUNTRIES_BEGIN,
      T.GET_DESTINATION_COUNTRIES_SUCCESS,
      T.GET_DESTINATION_COUNTRIES_FAIL,
    ],
  };
};
